module.exports = __webpack_public_path__ + "static/media/Automatic.018fa79e.svg";